<template>
  <list
    :list="domainList"
    :infiniteId="infiniteId"
    :headers="headers"
    :loading="loading"
    @load="fetchList"
    @reload="reloadList"
  >
    <template slot="default" slot-scope="slotProps">
      <domain-list-item
        :item="slotProps.item"
        @duplicated="reloadList"
        @deleted="reloadList"
        @edited="reloadList"
        @selected="emitSelected"
      />
    </template>
  </list>
</template>

<script>
import DomainListItem from "@components/modules/domain/list/item/DomainListItem";
import List from "@components/generic/list/List.vue";

export default {
  components: {
    List,
    DomainListItem,
  },
  data() {
    return {
      loading: false,
      headers: [
        {
          text: this.$t("message.generics.message.status"),
          value: "",
          sortable: false,
        },
        {
          text: this.$t("message.email.message.domain"),
          value: "",
          sortable: false,
        },
        { text: "", value: "", sortable: false },
      ],
      domainList: [],
      infiniteId: +new Date(),
      filter: {
        page: 0,
        filter: "",
      },
    };
  },
  props: {},
  created() {
    // EventBus.$on("AUTOMATION_SEARCH", this.searchList);
  },
  beforeDestroy() {
    // EventBus.$off("AUTOMATION_SEARCH", this.searchList);
  },
  methods: {
    async searchList(search) {
      this.filter.filter = search;
      this.reloadList();
    },
    async reloadList() {
      this.filter.page = 0;
      this.domainList = [];

      this.infiniteId++;
    },
    async fetchList($state) {
      this.loading = true;

      const domainList = await this.$api.marketing.email.dns.list();

      this.domainList = domainList;

      $state.complete();

      this.loading = false;
    },
    emitSelected(domain) {
      this.$emit("selected", domain);
    },
  },
};
</script>

<style lang="scss" scoped>
.marketing-automation-list {
  .marketing-automation-list-table {
    ::v-deep .v-table__overflow {
      padding-bottom: 100px;
    }
  }
}
</style>
